/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import authentication from "../../msalb2creact";
import authenticationsaml from "../../msalb2creact";
import DetailsList from "../../components/Listing/DetailsList";
import DownloadList from "../../components/Listing/DownloadList";
import { Advantages } from "../../components/CartaoAssociado/Advantages";
import { CardSection } from "../../components/CartaoAssociado/CardSection";
import { Loading } from "../../components/Loading/Loading";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { NavLink } from "react-router-dom";
import {
    ReactPlugin,
    withAITracking,
} from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { GlossaryPopup } from "../../components/Glossary/GlossaryPopup";

/* MODULE IMPORTS */
import React, { Component } from "react";

/* SAME FOLDER IMPORTS*/
import ColunaDireita from "./ColunaDireita";
import ColunaEsquerda from "./ColunaEsquerda";

/* CSS IMPORT */
import "./TabelaCandidatos.css";
import getadb2cauth from "../../getadb2cauth";
import pdfIconImg from "../../images/pdfIcon.svg";
import downloadImg from "../../images/download.png";

var reactPlugin = new ReactPlugin();

export class TabelaCandidatos extends Component {
    static displayName = TabelaCandidatos.name;

    constructor(props) {
        super(props);
    }

    getListaACandidatos() {
        return {
            name: "Lista A",
            slogan: "Crescer com confiança, ambição, determinação, visão de futuro",
            pdfUrl: "https://www.montepio.org/wp-content/uploads/2025/11/LISTA_A_PROGRAMA-1.pdf",
            mesaAssembleiaGeral: {
                titulo: "Mesa da Assembleia Geral",
                fotoPrincipal: require("../../images/FotoA.jpg"),
                membros: [
                    { nome: "Maria de Belém Roseira", cargo: "Presidente" },
                    { nome: "José Alberto Pitacas", cargo: "Secretário" },
                    { nome: "António Dias Sequeira", cargo: "Secretário" },
                    { nome: "António Manuel Gouveia", cargo: "Suplente" },
                    { nome: "António Pereira Gaio", cargo: "Suplente" }
                ]
            },
            conselhoAdministracao: {
                titulo: "Conselho de Administração",
                fotoPrincipal: require("../../images/FotoB.jpg"),
                membros: [
                    { nome: "Virgílio Boavista Lima", cargo: "Presidente" },
                    { nome: "Idália Salvador Serrão", cargo: "Vogal" },
                    { nome: "Rui Matos Heitor", cargo: "Vogal" },
                    { nome: "Fernando Centeno Amaro", cargo: "Vogal" },
                    { nome: "Hélio Gomes Marques", cargo: "Vogal" },
                    { nome: "José Eduardo Martins", cargo: "Vogal Não Executivo" },
                    { nome: "Maria da Conceição Zagalo", cargo: "Vogal Não Executiva" }
                ]
            },
            conselhoFiscal: {
                titulo: "Conselho Fiscal",
                fotoPrincipal: require("../../images/FotoC.jpg"),
                membros: [
                    { nome: "Víctor Seabra Franco", cargo: "Presidente" },
                    { nome: "Ana Paula Harfouche", cargo: "Vogal" },
                    { nome: "Paulo da Silva Raimundo", cargo: "Vogal" },
                    { nome: "José Domingos Barão", cargo: "Suplente" },
                    { nome: "António Mendes de Almeida", cargo: "Suplente" }
                ]
            }
        };
    }

    renderListaAPrincipal() {
        const listaA = this.getListaACandidatos();

        return (
            <div className="lista-a-container">
                <div className="tabelaCandidatosTitulo">
                    Mesa da Assembleia Geral, Conselho de Administração e Conselho Fiscal
                </div>
                <div className="lista-a-content">
                    <div className="lista-a-esquerda">
                        <div className="lista-a-nome">{listaA.name}</div>
                        <div className="lista-a-slogan">{listaA.slogan}</div>
                        <div className="lista-a-pdf">
                            <img
                                src={pdfIconImg}
                                alt=""
                                height="26px"
                                width="26px"
                            />
                            <div>
                                <div className="glossary-title">Candidatos e Programa</div>
                                <a
                                    className="glossary-download-button"
                                    href={listaA.pdfUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div>Clique aqui</div>
                                    <img
                                        src={downloadImg}
                                        alt="Botão de Download"
                                        height="7.5px"
                                        width="7.2px"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="lista-a-direita">
                        {/* Mesa da Assembleia Geral */}
                        <div className="orgao-section">
                            <div className="orgao-header">
                                <div className="orgao-titulo">{listaA.mesaAssembleiaGeral.titulo}</div>
                            </div>
                            <div className="orgao-content">
                                <img
                                    src={listaA.mesaAssembleiaGeral.fotoPrincipal}
                                    alt="Mesa da Assembleia Geral"
                                    className="orgao-foto-central"
                                />
                                <div className="orgao-membros">
                                    {listaA.mesaAssembleiaGeral.membros.map((membro, index) => (
                                        <div key={index} className="membro-item">
                                            <span className="membro-nome">{membro.nome}</span>
                                            <span className="membro-cargo"> - {membro.cargo}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Conselho de Administração */}
                        <div className="orgao-section">
                            <div className="orgao-header">
                                <div className="orgao-titulo">{listaA.conselhoAdministracao.titulo}</div>
                            </div>
                            <div className="orgao-content">
                                <img
                                    src={listaA.conselhoAdministracao.fotoPrincipal}
                                    alt="Conselho de Administração"
                                    className="orgao-foto-central"
                                />
                                <div className="orgao-membros">
                                    {listaA.conselhoAdministracao.membros.map((membro, index) => (
                                        <div key={index} className="membro-item">
                                            <span className="membro-nome">{membro.nome}</span>
                                            <span className="membro-cargo"> - {membro.cargo}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Conselho Fiscal */}
                        <div className="orgao-section">
                            <div className="orgao-header">
                                <div className="orgao-titulo">{listaA.conselhoFiscal.titulo}</div>
                            </div>
                            <div className="orgao-content">
                                <img
                                    src={listaA.conselhoFiscal.fotoPrincipal}
                                    alt="Conselho Fiscal"
                                    className="orgao-foto-central"
                                />
                                <div className="orgao-membros">
                                    {listaA.conselhoFiscal.membros.map((membro, index) => (
                                        <div key={index} className="membro-item">
                                            <span className="membro-nome">{membro.nome}</span>
                                            <span className="membro-cargo"> - {membro.cargo}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderListasSecundarias() {
        // Filter lists for Assembleia de Representantes (type 1)
        const listasAssembleiaRepresentantes = this.props.listasAssembleiaRepresentantes || [];

        if (listasAssembleiaRepresentantes.length === 0) {
            return null;
        }

        // Mapeamento hardcoded das fotos para cada lista
        const photoMapping = {
            "Lista A": require("../../images/FotoD.jpg"),
            "Lista B": require("../../images/FotoE.jpg")
        };

        return (
            <div className="listas-secundarias-container">
                <div className="tabelaCandidatosTitulo">
                    Assembleia de Representantes
                </div>
                <div className="tabelaCandidatos">
                    {listasAssembleiaRepresentantes.map((content, index) => (
                        <div key={index} className="coluna row candidato">
                            <div className="esquerda col-4">
                                <ColunaEsquerda
                                    description={content.description}
                                    pdfUrl={content.pdfUrl}
                                    name={content.name}
                                    photoUrl={photoMapping[content.name] || require("../../images/user.svg")}
                                ></ColunaEsquerda>
                            </div>
                            <div className="direita col-8">
                                <ColunaDireita
                                    description={content.description}
                                    pdfUrl={content.pdfUrl}
                                    name={content.name}
                                ></ColunaDireita>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="tabelasCandidatos">
                <div className="row">
                    <div className="col-md-12 tipoEleicao position-table">
                        {this.renderListaAPrincipal()}
                        {this.renderListasSecundarias()}
                    </div>
                </div>
            </div>
        );
    }
}

export default withAITracking(reactPlugin, TabelaCandidatos);
